import React, { useState, useRef, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import allCities from '../Editprofile/allCities.js';

function ServiceType({ setServiceType, serviceType, selectedCountry, setSelectedCountry, selectedCity, setSelectedCity }) {

    const countries = Object.keys(allCities);
    const [countrySearch, setCountrySearch] = useState(''); // Country search input
    const [citySearch, setCitySearch] = useState(''); // City search input
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false); // Track if country dropdown is open
    const [isCityDropdownOpen, setIsCityDropdownOpen] = useState(false); // Track if city dropdown is open

    const countryInputRef = useRef(null); // Ref for country search input
    const cityInputRef = useRef(null); // Ref for city search input

    const filteredCountries = countries.filter(country =>
        country.toLowerCase().includes(countrySearch.toLowerCase())
    );

    const filteredCities = selectedCountry
        ? allCities[selectedCountry]?.filter(city =>
            city?.toLowerCase()?.includes(citySearch?.toLowerCase())
        )
        : [];

    const handleCountrySelect = (country) => {
        setSelectedCountry(country);
        setSelectedCity(null);
        setCitySearch('');
    };

    const handleCitySelect = (city) => {
        setSelectedCity(city);
    };

    const handleServiceTypeChange = (type) => {
        setServiceType(type);
    };

    return (
        <>
            <h6 className="forpad">Service Type <span>*</span></h6>
            <div className="mainworldbox cp">
                <div className="radio-group cp">
                    <input
                        className="radio-input"
                        name="radio-group"
                        id="radio1"
                        type="radio"
                        checked={serviceType === "Digital" || serviceType === "digital"}
                        onChange={() => handleServiceTypeChange("Digital")}
                    />
                    <label className="radio-label digitalworldpara" htmlFor="radio1">
                        <span className="radio-inner-circle"></span>
                        Digital (worldwide)
                    </label>
                </div>
            </div>
            <div className="jjkjkjkjk mb-3 cp">
                <div className="radio-group cp">
                    <input
                        className="radio-input"
                        name="radio-group"
                        id="radio122"
                        type="radio"
                        checked={serviceType === "Physical" || serviceType === "physical"}
                        onChange={() => handleServiceTypeChange("Physical")}
                    />
                    <label className="radio-label digitalworldpara" htmlFor="radio122">
                        <span className="radio-inner-circle"></span>
                        Physical (specific location)
                    </label>
                </div>
                {(serviceType === "Physical" || serviceType === "physical") && <div className='threedrop mt-3'>
                    {/* Country Dropdown */}
                    <div className='first'>
                        <h2>Country</h2>
                        <div className='maindrop'>
                            <Dropdown
                                onToggle={(isOpen) => setIsCountryDropdownOpen(isOpen)}
                            >
                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    {selectedCountry || "Select Country"}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M13.3332 8.3335L9.99984 11.6668L6.6665 8.3335"
                                            stroke="#013159"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <div className='maintextdrop'>
                                        <div className='mainsinputsssss'>
                                            <input
                                                type='text'
                                                placeholder='Search...'
                                                value={countrySearch}
                                                ref={countryInputRef} // Attach ref
                                                onChange={(e) => setCountrySearch(e.target.value)}
                                            />
                                        </div>
                                        <div className='country'>
                                            <div className='inner'>
                                                {filteredCountries.map((country, index) => (
                                                    <Dropdown.Item className='dropssss' key={index} onClick={() => handleCountrySelect(country)}>
                                                        {country}
                                                    </Dropdown.Item>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>

                    {/* City Dropdown */}
                    <div className='first'>
                        <h2>City</h2>
                        <div className='maindrop'>
                            <Dropdown
                                onToggle={(isOpen) => setIsCityDropdownOpen(isOpen)}
                            >
                                <Dropdown.Toggle
                                    variant="success"
                                    id="dropdown-basic"
                                    disabled={!selectedCountry} // Disable if no country is selected
                                >
                                    <div className='parentssssbuttonsss'>
                                        {selectedCity || "Select City"}
                                    </div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M13.3332 8.3335L9.99984 11.6668L6.6665 8.3335"
                                            stroke="#013159"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <div className='maintextdrop'>
                                        <div className='mainsinputsssss'>
                                            <input
                                                type='text'
                                                placeholder='Search...'
                                                value={citySearch}
                                                ref={cityInputRef} // Attach ref
                                                onChange={(e) => setCitySearch(e.target.value)}
                                            />
                                        </div>
                                        <div className='parentchec'>
                                            {/* Render filtered cities */}
                                            {filteredCities?.map((city, index) => (
                                                <div className='mainchec p-0' key={index} onClick={() => handleCitySelect(city)}>
                                                    <div className="checkboxmainss">
                                                        <Dropdown.Item className='dropssss'>{city}</Dropdown.Item>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>}
            </div>
        </>
    );
}

export default ServiceType;